function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurServices2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EEF3FF"
    },
    cx: 239.97,
    cy: 249.891,
    rx: 180.208,
    ry: 172.312
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DAE5FD"
    },
    points: "108.471,289.281 134.871,310.778 148.841,309.222 148.841,281.25 113.134,268.098  107.575,287.824  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DAE5FD"
    },
    d: "M206.822,309.222h-71.335v-53.916c0-10.433,8.458-18.891,18.891-18.891h52.444V309.222z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E27A37"
    },
    points: "135.451,218.774 177.23,196.73 172.644,181.676 126.989,194.204  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F55B8"
    },
    d: "M167.435,211.751h18.24v-26.663c0-6.958-5.641-12.598-12.598-12.598h-5.641V211.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27A37"
    },
    d: "M179.151,200.024c8.169,11.277,5.986,26.798-4.877,34.667 c-10.863,7.869-26.291,5.106-34.46-6.171c-8.169-11.277-5.986-26.798,4.877-34.667 C155.553,185.984,170.982,188.747,179.151,200.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27A37"
    },
    d: "M177.739,207.008c0.07,3.919,3.304,7.04,7.223,6.969c3.919-0.07,7.04-3.304,6.97-7.223 c-0.07-3.919-3.304-7.04-7.223-6.969C180.789,199.855,177.669,203.089,177.739,207.008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262959"
    },
    d: "M155.686,210.431c0.497,1.631,1.702,2.709,2.692,2.408s1.389-1.868,0.892-3.5 s-1.702-2.709-2.692-2.408C155.588,207.233,155.188,208.8,155.686,210.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262959"
    },
    d: "M139.154,214.818c0.497,1.631,1.702,2.709,2.692,2.408c0.99-0.301,1.389-1.868,0.892-3.5 c-0.497-1.631-1.702-2.709-2.692-2.408C139.056,211.62,138.657,213.186,139.154,214.818z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262959"
    },
    d: "M148.947,226.877c0.309,1.014,1.076,1.815,2.098,2.288c1.281,0.603,2.971,0.726,4.664,0.21 c1.674-0.51,3.004-1.532,3.731-2.747c0.604-0.968,0.8-2.073,0.489-3.097c-0.699-2.296-2.753-0.217-5.785,0.707 C151.111,225.162,148.248,224.581,148.947,226.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD2F2F"
    },
    d: "M151.045,229.165c1.281,0.603,2.971,0.726,4.664,0.21c1.674-0.51,3.004-1.532,3.731-2.747 c-1.352-0.905-3.107-1.207-4.809-0.688C152.938,226.455,151.659,227.681,151.045,229.165z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F55B8"
    },
    d: "M178.386,212.257l1.659-0.505l0.617-25.056c-0.3-4.883-6.62-8.02-11.503-7.719l-6.609,0.408 l8.888,29.17C172.333,211.495,175.444,213.153,178.386,212.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F55B8"
    },
    d: "M165.365,197.576c-5.714,3.265-13.95,7.072-22.81,8.242 c-16.901,2.231-30.115-14.365-24.354-30.409l1.847-5.146c0,0,4.574,6.243,16.238,2.006c14.357-5.215,32.036-6.908,36.574,6.032 C175.428,185.622,172.101,193.727,165.365,197.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27A37"
    },
    d: "M182.71,238.935c-3.7,4.32-6.69,6.71-7.59,7.39c-0.18,0.13-0.27,0.2-0.27,0.2l-1.12,0.73 c-1.93,1.11-4.33,1.76-6.92,1.76c-0.18,0-0.36,0-0.54-0.01c-2.27-1.28-4.17-3.32-5.25-6.09l-1.47-3.75l-1.06-2.7l12-4.71 l7.85-3.08l0.3-0.12l0.53,1.35L182.71,238.935z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#323675"
    },
    cx: 186.666,
    cy: 207.547,
    r: 11.819
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323675"
    },
    d: "M178.38,240.155c0,2.4-1.25,4.57-3.26,6.17c-0.18,0.13-0.27,0.2-0.27,0.2l-1.12,0.73 c-1.93,1.11-4.33,1.76-6.92,1.76c-0.18,0-0.36,0-0.54-0.01c-6.14-0.22-11.03-4.09-11.03-8.85c0-0.51,0.06-1,0.17-1.49 c0.92-4.18,5.67-7.37,11.4-7.37c1.28,0,2.52,0.16,3.68,0.46c1.48,0.38,2.82,0.98,3.96,1.75c0.25,0.16,0.48,0.33,0.7,0.52 C177.15,235.615,178.38,237.775,178.38,240.155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323675"
    },
    d: "M198.16,210.275c-0.18,0.57-0.35,1.13-0.54,1.69c-4.12,12.53-10.11,21.37-14.91,26.97 c-3.7,4.32-6.69,6.71-7.59,7.39c-0.18,0.13-0.27,0.2-0.27,0.2l-1.12,0.73l-4.58-8.9c0.82-0.63,1.6-1.27,2.34-1.94 c1.07-0.94,2.06-1.92,2.96-2.91c1.48-1.59,2.77-3.22,3.89-4.83c2.41-3.48,4.07-6.89,5.19-9.73c0.14-0.37,0.28-0.73,0.41-1.08 c0.56-1.54,0.96-2.88,1.23-3.9c0.37-1.39,0.5-2.21,0.5-2.21l4.8-0.57L198.16,210.275z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27A37"
    },
    d: "M175.685,237.953l10.605,5.477c2.249,1.161,5.014,0.28,6.176-1.969l7.149-13.843 c1.161-2.249,0.28-5.014-1.969-6.176l-10.606-5.477c-2.249-1.161-5.014-0.28-6.175,1.969l-7.149,13.843 C172.555,234.027,173.436,236.792,175.685,237.953z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4F55B8"
    },
    points: "87.502,294.956 115.017,249.016 127.204,256.806 100.729,300.924 88.735,309.039  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27A37"
    },
    d: "M116.195,281.067h-7.962c-2.971,0-5.403-2.431-5.403-5.403l0,0c0-2.972,2.431-5.403,5.403-5.403 h7.962c2.971,0,5.403,2.431,5.403,5.403l0,0C121.598,278.636,119.166,281.067,116.195,281.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27A37"
    },
    d: "M93.67,285.623l-1.966-0.976c-2.801-1.39-3.945-4.788-2.554-7.589l5.379-10.837 c1.39-2.801,4.788-3.944,7.589-2.554l1.966,0.976c2.801,1.39,3.944,4.788,2.554,7.589l-5.379,10.837 C99.869,285.87,96.471,287.013,93.67,285.623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8D9FD"
    },
    d: "M112.749,252.802l12.513,7.28l2.683-4.216c2.162-3.398,1.173-7.904-2.214-10.083h0 c-3.487-2.243-8.139-1.145-10.254,2.421L112.749,252.802z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C8D9FD"
    },
    points: "87.502,294.815 100.729,300.924 92.709,306.351 88.365,304.666  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DAE5FD"
    },
    d: "M153.008,315.777H77.726c-1.81,0-3.277-1.467-3.277-3.277l0,0c0-1.81,1.467-3.277,3.277-3.277 h75.282c1.81,0,3.277,1.467,3.277,3.277l0,0C156.286,314.31,154.818,315.777,153.008,315.777z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#323675",
      strokeMiterlimit: 10
    },
    d: "M168.81,249.015c0,4.773-4,4.773-4,9.547 c0,4.775,4,4.775,4,9.55c0,4.773-4,4.773-4,9.547c0,4.777,4,4.777,4,9.553c0,4.777-4,4.777-4,9.553"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E27A37",
      strokeWidth: 14,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M339.7,157.733v85.381 c0,13.63-12.791,23.643-26.023,20.371l-35.714-8.832"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0D4FD"
    },
    d: "M352.111,186.581v57.053c0,10.333-4.665,19.921-12.805,26.293 c-5.968,4.665-13.157,7.116-20.511,7.116c-2.7,0-5.41-0.331-8.099-0.993l-35.715-8.833c-6.651-1.645-10.716-8.368-9.071-15.029 c1.655-6.651,8.368-15.711,15.029-14.066l35.715,8.833c3.527,0.879,6.123-0.61,7.344-1.572c1.231-0.962,3.289-3.113,3.289-6.744 v-52.059H352.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27A37"
    },
    d: "M335.618,126.579L335.618,126.579c-2.192,0-3.984,1.793-3.984,3.984v33.408 c0,2.191,1.793,3.984,3.984,3.984l0,0c2.192,0,3.984-1.793,3.984-3.984v-33.408C339.602,128.372,337.809,126.579,335.618,126.579z "
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7691 -0.6392 0.6392 0.7691 -22.7978 254.3273)",
    style: {
      fill: "#E27A37"
    },
    cx: 340.567,
    cy: 158.714,
    rx: 13.88,
    ry: 13.88
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0D4FD"
    },
    d: "M230.435,232.083l18.802,55.852l-3.283,75.148h-41.559v-71.52l-7.43,10.87l-3.76,5.51l-12.36,18.1 l-0.1,0.14l-5.24-3.37l-8.54-5.5l-2.21-1.42c-0.25-0.16-0.48-0.33-0.71-0.5l-0.03-0.03c-1.18-0.92-2.12-2.05-2.79-3.32 c-0.01,0-0.01-0.01-0.01-0.03c-0.65-1.27-1.03-2.66-1.12-4.07c-0.13-2.1,0.39-4.25,1.61-6.15l1.43-2.21l4.1-6.35l31.08-48.13 c0.13-0.2,0.26-0.4,0.4-0.59c2.2-3.19,5.14-5.75,8.53-7.48c2.12-1.09,4.41-1.86,6.8-2.25l5.95-0.98L230.435,232.083z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27A37"
    },
    d: "M259.88,212.014v19.274c0,4.639-2.1,8.669-5.141,10.591l-5.503-5.941l-5.399,6.206 c-3.289-1.79-5.606-5.978-5.606-10.856v-19.274H259.88z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "249.236,235.939 243.837,242.145 240.631,245.837 230.215,232.95 238.138,226.94  238.231,227.013  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "268.04,232.95 257.997,245.475 254.739,241.938 249.236,235.939 259.88,227.137  260.117,226.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C0D4FD"
    },
    points: "296.61,242.055 296.59,248.495 296.57,253.855 296.55,259.245 296.55,259.255  296.5,272.535 296.47,280.685 296.47,364.365 245.954,364.365 249.236,287.935 268.4,233.065 274.83,235.115 281.96,237.385  285.78,238.605 287.88,239.275 293.07,240.925 293.35,241.015 294.35,241.335 295.84,241.805 295.9,241.825  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.008,
    y: 181.753,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.392,
    height: 4.791
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 227.117,
    y: 166.016,
    style: {
      fill: "#E27A37"
    },
    width: 45.635,
    height: 15.737
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27A37"
    },
    d: "M226.24,188.976c-4.527,13.169,2.085,27.379,14.77,31.74c12.685,4.361,26.638-2.779,31.165-15.947 c4.528-13.169-2.085-27.38-14.77-31.741C244.721,168.667,230.768,175.807,226.24,188.976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F55B8"
    },
    d: "M275.313,175.365c0,0-6.86,3.694-16.247,6.053c-4.961,1.247-10.629,2.12-16.362,1.878 c-17.032-0.719-27.184-19.346-18.741-34.156l2.708-4.75c0,0,3.427,6.938,15.649,4.778 C261.463,145.784,284.922,148.947,275.313,175.365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27A37"
    },
    d: "M281.854,194.709c0,3.92-3.178,7.098-7.098,7.098s-4.379-3.178-4.379-7.098 c0-3.92,0.459-7.098,4.379-7.098S281.854,190.789,281.854,194.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27A37"
    },
    d: "M229.627,191.733c1.075,3.77-1.109,7.697-4.878,8.772c-3.77,1.075-7.697-1.109-8.772-4.878 c-1.075-3.77,1.109-7.697,4.878-8.772C224.624,185.78,228.552,187.964,229.627,191.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F55B8"
    },
    d: "M275.061,196.872h1.734l5.698-23.853c1.137-4.758-1.8-9.537-6.559-10.672l-6.441-1.537v30.494 C269.494,194.379,271.986,196.872,275.061,196.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F55B8"
    },
    d: "M224.719,196.364h-1.734l-5.698-23.853c-1.137-4.758,1.8-9.537,6.559-10.672l6.441-1.536v30.494 C230.287,193.871,227.794,196.364,224.719,196.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262959"
    },
    d: "M240.375,193.276c0,1.705-0.839,3.088-1.873,3.088c-1.034,0-1.873-1.382-1.873-3.088 c0-1.705,0.839-3.088,1.873-3.088C239.536,190.188,240.375,191.57,240.375,193.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262959"
    },
    d: "M259.88,193.276c0,1.705-0.839,3.088-1.873,3.088c-1.034,0-1.873-1.382-1.873-3.088 c0-1.705,0.839-3.088,1.873-3.088C259.041,190.188,259.88,191.57,259.88,193.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262959"
    },
    d: "M253.81,205.135c0,1.06-0.5,2.05-1.34,2.8c-1.05,0.95-2.63,1.56-4.4,1.56 c-1.75,0-3.32-0.59-4.37-1.54c-0.86-0.75-1.37-1.75-1.37-2.82c0-2.4,2.57-1.01,5.74-1.01S253.81,202.735,253.81,205.135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD2F2F"
    },
    d: "M252.47,207.935c-1.05,0.95-2.63,1.56-4.4,1.56c-1.75,0-3.32-0.59-4.37-1.54 c1.03-1.26,2.62-2.06,4.4-2.06C249.87,205.895,251.45,206.695,252.47,207.935z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F55B8"
    },
    d: "M135.644,294.631c6.543,10.271,30.072,45.836,35.037,53.336c0.579,0.875,1.555,1.396,2.604,1.396 h48.404c2.426,0,3.927-2.642,2.686-4.726l-30.984-52.011c-0.572-0.959-1.605-1.541-2.721-1.526 c-8.277,0.112-42.768,0.578-53.507,0.723C135.73,291.842,134.875,293.423,135.644,294.631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27A37"
    },
    d: "M158.246,331.61l-1.972,0.965c-2.809,1.375-6.2,0.213-7.575-2.595l-5.32-10.866 c-1.375-2.808-0.213-6.2,2.595-7.575l1.972-0.965c2.808-1.375,6.2-0.213,7.575,2.595l5.32,10.866 C162.216,326.843,161.054,330.235,158.246,331.61z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.422,
    y: 341.035,
    style: {
      fill: "#88A9F2"
    },
    width: 74.82,
    height: 23.33
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4F55B8"
    },
    points: "243.837,242.145 248.07,247.255 243.015,269.454 249.236,287.935 255.099,271.15  251.225,246.62 254.739,241.938 249.236,235.939  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#323675",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 165.147,
    y1: 308.455,
    x2: 182.37,
    y2: 308.455
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#323675",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 167.898,
    y1: 314.02,
    x2: 185.121,
    y2: 314.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#323675",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M319.227,336.363 c-1.763,0-2.931-1.83-2.188-3.429l26.368-56.725c1.054-2.268,3.328-3.719,5.829-3.719"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0D4FD"
    },
    d: "M415.897,336.692h-93.295c-1.763,0-2.931-1.83-2.188-3.429l26.368-56.725 c1.054-2.268,3.328-3.719,5.829-3.719h90.733c1.763,0,2.931,1.83,2.188,3.429l-27.448,59.048 C417.689,336.147,416.836,336.692,415.897,336.692z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4F55B8"
    },
    points: "372.162,359.472 358.207,359.472 378.317,316.547 392.272,316.547  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.978,
    y: 359.471,
    style: {
      fill: "#4F55B8"
    },
    width: 73.74,
    height: 3.97
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#323675",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 355.718,
    y1: 359.471,
    x2: 376.581,
    y2: 315.373
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#323675",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    cx: 376.685,
    cy: 221.884,
    r: 3.399
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#323675",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 305.26,
    y1: 140.283,
    x2: 305.26,
    y2: 148.202
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#323675",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 309.219,
    y1: 144.243,
    x2: 301.301,
    y2: 144.243
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#323675",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "120.919,329.607 123.796,334.591  126.674,339.574 120.919,339.574 115.165,339.574 118.042,334.591  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#323675",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M109.247,224.582 c0,1.49-1.208,2.698-2.698,2.698c-1.49,0-2.698-1.208-2.698-2.698c0-1.49,1.208-2.698,2.698-2.698 C108.039,221.884,109.247,223.092,109.247,224.582z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.122,
    y: 147.267,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 161.7579 -89.1776)",
    style: {
      fill: "none",
      stroke: "#323675",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 6.812,
    height: 6.812
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#88A9F2"
    },
    points: "321.978,306.501 320.653,365.426 279.65,367.103 286.776,321.574  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88A9F2"
    },
    d: "M298.906,351.283h-34.304v-59.417h43.47c10.558,0,17.253,11.316,12.171,20.57L298.906,351.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88A9F2"
    },
    d: "M298.04,318.495c-0.2,3.69,6.912,7.512,6.012,11.112c-0.43,1.74-1.392,3.608-2.042,5.228 c-0.71,1.76-1.421,3.73-2.591,6.2c-1.44,3.04-10.589,6.53-12.479,10.25c-0.9,1.77-1.84,3.6-2.81,5.45c-1.3,2.51-2.65,5.07-4,7.63 h-53.08l0.14-0.79h-8.38c-0.11,0-0.21,0-0.32-0.01c-6.67-0.11-11.84-3.85-14.52-8.89c-2.11-3.96-2.67-8.73-1.2-13.18 c0.31-0.94,0.71-1.86,1.2-2.76c0.67-1.22,1.51-2.39,2.54-3.49l4.45-5.92l7.96-10.59l11.09-14.74l1.75-2.33 c1.28-1.71,2.76-3.24,4.38-4.57c4.7-3.85,10.64-6.02,16.84-6.02h23.7c0,0,0.04,0.15,0.15,0.4c0.05,0.11,0.11,0.24,0.19,0.39 c1.13,2.25,5.57,8.27,19.45,4.41c0.04-0.01,0.09-0.03,0.14-0.04c0,0,0.06,0.33,0.17,0.94 C297.26,300.015,298.57,308.895,298.04,318.495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27A37"
    },
    d: "M300.347,344.744l18.296,1.976c3.189,0.345,6.073,2.051,7.91,4.68l9.058,12.961l-12.906,1.065 l-22.637-8.673L300.347,344.744z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E27A37"
    },
    points: "325.051,268.883 283.272,246.838 287.859,231.784 333.513,244.313  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F55B8"
    },
    d: "M293.067,261.86h-18.24v-26.663c0-6.958,5.64-12.598,12.598-12.598h5.641V261.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27A37"
    },
    d: "M281.351,250.132c-8.169,11.277-5.986,26.798,4.877,34.667c10.863,7.869,26.291,5.106,34.46-6.171 c8.169-11.277,5.986-26.798-4.877-34.667C304.949,236.092,289.521,238.855,281.351,250.132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27A37"
    },
    d: "M282.763,257.116c-0.07,3.919-3.304,7.04-7.223,6.969c-3.919-0.07-7.04-3.304-6.97-7.223 c0.07-3.919,3.304-7.04,7.224-6.97C279.713,249.963,282.834,253.197,282.763,257.116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262959"
    },
    d: "M304.817,260.539c-0.497,1.631-1.702,2.709-2.692,2.408c-0.99-0.302-1.389-1.868-0.892-3.5 c0.497-1.631,1.702-2.709,2.692-2.408C304.915,257.341,305.314,258.908,304.817,260.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262959"
    },
    d: "M321.348,264.926c-0.497,1.631-1.702,2.709-2.692,2.408c-0.99-0.302-1.389-1.868-0.892-3.5 c0.497-1.631,1.702-2.709,2.692-2.408C321.446,261.728,321.846,263.295,321.348,264.926z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262959"
    },
    d: "M311.555,276.985c-0.309,1.014-1.076,1.815-2.098,2.288c-1.281,0.603-2.971,0.726-4.664,0.21 c-1.674-0.51-3.004-1.532-3.731-2.747c-0.604-0.968-0.801-2.073-0.489-3.097c0.7-2.296,2.753-0.217,5.785,0.707 C309.391,275.27,312.255,274.689,311.555,276.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD2F2F"
    },
    d: "M309.457,279.273c-1.281,0.603-2.971,0.726-4.664,0.21c-1.674-0.51-3.004-1.532-3.731-2.747 c1.353-0.905,3.107-1.207,4.809-0.688C307.565,276.564,308.843,277.789,309.457,279.273z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F55B8"
    },
    d: "M282.117,262.365l-1.659-0.505l-2.494-24.553c0.3-4.883,8.498-8.524,13.381-8.222l6.609,0.408 l-8.888,29.17C288.169,261.603,285.058,263.261,282.117,262.365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F55B8"
    },
    d: "M295.137,247.684c5.714,3.265,13.95,7.072,22.81,8.242c16.901,2.231,30.115-14.365,24.355-30.409 l-1.848-5.146c0,0-4.574,6.243-16.238,2.006c-14.357-5.215-32.036-6.908-36.574,6.032 C285.075,235.73,288.401,243.835,295.137,247.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27A37"
    },
    d: "M302.01,286.575l-2.527,6.445c-3.742,9.541-17.13,10.473-21.824,1.362 c-0.739-1.435-0.979-2.517-0.979-2.517l5.18-13.2L302.01,286.575z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C0D4FD"
    },
    points: "276.834,300.722 276.68,341.775 295.266,344.231 301.745,300.722  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "270.159,291.075 279.325,285.125 291.729,299.291 301.063,289.281 306.045,292.241  296.61,310.85 292.016,303.456 283.842,310.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4F55B8"
    },
    points: "285.814,309.066 287.953,313.84 276.68,341.775 295.266,344.231 291.419,315.068  295.632,309.277 292.016,303.456  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#323675",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "300.347,344.744 239.97,338.653  247.273,321.574  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323675"
    },
    d: "M416.515,370.765H97c-2.014,0-3.662-1.648-3.662-3.662l0,0c0-2.014,1.648-3.662,3.662-3.662h319.515 c2.014,0,3.662,1.648,3.662,3.662l0,0C420.178,369.117,418.53,370.765,416.515,370.765z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurServices2);
export default __webpack_public_path__ + "static/media/OurServices2.0b9de7fae586fa0908b9bb9f75beffa1.svg";
export { ForwardRef as ReactComponent };